/* eslint-disable import/no-cycle */
import {action, decorate, observable} from 'mobx';
import {Api} from '../middleware/api';
import {EntityStore} from './entityStore';
import {KeyPerformanceIndicator} from '../models/keyPerformanceIndicator';
import {
  byMaterialEndpoint, byOrderEndpoint, byTimeEndpoint, oeeByMaterialEndpoint, oeeByOrderEndpoint, oeeByTimeEndpoint
} from '../middleware/endpoints/keyPerformanceIndicator';

export class KeyPerformanceIndicatorStore extends EntityStore {
  kpis = [];

  constructor(rootStore) {
    super(rootStore, 'kpis', Api.keyPerformanceIndicator, KeyPerformanceIndicator);
  }

  getDependencies() {
    return [
      {
        store: this.rootStore.unitOfMeasurementStore,
        modelId: 'unitOfMeasureId',
      },
    ];
  }

  loadKpiByFilter(filter) {
    if (filter.materialId) {
      return this.loadKpiByMaterial(filter);
    }
    if (filter.orderId) {
      return this.loadKpiByOrder(filter);
    }
    return this.loadKpiByTime(filter);
  }

  loadKpiByTime({workplaceId, fromDate, toDate, resolution, kpiId}) {
    return this.api[byTimeEndpoint]({
      params: {workplaceId, fromDate, toDate, resolution, kpiId},
    }).then((response) => response.data.series || []).catch((e) => this.handleApiError(e, byTimeEndpoint));
  }

  loadKpiByMaterial({workplaceId, fromDate, toDate, materialId, resolution, kpiId}) {
    return this.api[byMaterialEndpoint]({
      params: {workplaceId, fromDate, toDate, materialId, resolution, kpiId},
    }).then((response) => response.data.series || []).catch((e) => this.handleApiError(e, byMaterialEndpoint));
  }

  loadKpiByOrder({workplaceId, orderId, resolution, kpiId}) {
    return this.api[byOrderEndpoint]({
      params: {workplaceId, orderId, resolution, kpiId},
    }).then((response) => response.data.series || []).catch((e) => this.handleApiError(e, byOrderEndpoint));
  }

  loadOeeByFilter(filter) {
    if (filter.materialId) {
      return this.loadOeeByMaterial(filter);
    }
    if (filter.orderId) {
      return this.loadOeeByOrder(filter);
    }
    return this.loadOeeByTime(filter);
  }

  loadOeeByTime({workplaceId, fromDate, toDate}) {
    return this.api[oeeByTimeEndpoint]({
      params: {workplaceId, fromDate, toDate},
    }).then((response) => response.data).catch((e) => this.handleApiError(e, oeeByTimeEndpoint));
  }

  loadOeeByMaterial({workplaceId, fromDate, toDate, materialId}) {
    return this.api[oeeByMaterialEndpoint]({
      params: {workplaceId, fromDate, toDate, materialId},
    }).then((response) => response.data).catch((e) => this.handleApiError(e, oeeByMaterialEndpoint));
  }

  loadOeeByOrder({workplaceId, orderId}) {
    return this.api[oeeByOrderEndpoint]({
      params: {workplaceId, orderId},
    }).then((response) => response.data).catch((e) => this.handleApiError(e, oeeByOrderEndpoint));
  }
}

decorate(KeyPerformanceIndicatorStore, {
  kpis: observable,
  series: observable,
  loadKpiByFilter: action,
  loadKpiByTime: action,
  loadKpiByMaterial: action,
  loadKpiByOrder: action,
  loadOeeByFilter: action,
  loadOeeByTime: action,
  loadOeeByMaterial: action,
  loadOeeByOrder: action,
});
